import { render, staticRenderFns } from "./BlockListShortcutsCustom.vue?vue&type=template&id=4e939166&"
import script from "./BlockListShortcutsCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListShortcutsCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports